import { DEFERRED_PREFETCH_ID } from '~~/shared/deferredPrefetch'

// Puts back the <link rel="prefetch"> hints the deferredPrefetch nitro plugin moved
// out of the head (server/plugins/deferredPrefetch.ts): once the app has hydrated and
// the browser is idle, so the lazy chunks are still cached before most first opens
// without competing with the entry chunk.

export const restorePrefetchHints = (): void => {
  const template = document.getElementById(DEFERRED_PREFETCH_ID)
  if (!(template instanceof HTMLTemplateElement)) {
    return
  }
  // Moved out of the inert template into the document, each link starts its prefetch.
  document.head.append(template.content)
  template.remove()
}

export default defineNuxtPlugin({
  name: 'deferred-prefetch',
  setup () {
    onNuxtReady(restorePrefetchHints)
  }
})
